// FIXME: Update this file to be type safe and remove this and next line
// @ts-strict-ignore
export abstract class BitFormControlAbstraction {
  disabled: boolean;
  required: boolean;
  hasError: boolean;
  error: [string, any];
}
